function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4.75,
  y: 8.75,
  width: 38.5,
  height: 30.5,
  rx: 2.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.75,
  y: 14.75,
  width: 38.5,
  height: 8.5,
  rx: 2.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

function SvgFullWidthImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSI0Ljc1IiB5PSI4Ljc1IiB3aWR0aD0iMzguNSIgaGVpZ2h0PSIzMC41IiByeD0iMi4yNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiAvPgogIDxyZWN0IHg9IjQuNzUiIHk9IjE0Ljc1IiB3aWR0aD0iMzguNSIgaGVpZ2h0PSI4LjUiIHJ4PSIyLjI1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIC8+Cjwvc3ZnPg==";
export { SvgFullWidthImage as ReactComponent };